<template>
    <pendo-multiselect
        :value="selectedOption"
        :options="options"
        value-key="state"
        @select="$emit('input', $event.state)">
        <template #selectedLabel="{ option }">
            <pendo-status-option
                v-if="option.state !== 'all'"
                :status-color-map="STATUS_COLOR_MAP"
                :option="option" />
        </template>
        <template #option="{ option }">
            <pendo-status-option
                v-if="option.state !== 'all'"
                :status-color-map="STATUS_COLOR_MAP"
                :option="option" />
        </template>
    </pendo-multiselect>
</template>

<script>
import { PendoMultiselect, PendoStatusOption } from '@pendo/components';
import { getStateOptions, STATUS_COLOR_MAP } from './verification-status.utils';

export default {
    name: 'VerificationFilter',
    components: {
        PendoMultiselect,
        PendoStatusOption,
    },
    props: {
        value: {
            type: String,
            default: 'all',
        },
    },
    emits: ['input'],
    data () {
        return {
            STATUS_COLOR_MAP,
            options: [],
        };
    },
    computed: {
        selectedOption () {
            const selectedOption = this.options.find(({ state }) => state === this.value);

            return selectedOption || this.options[0];
        },
    },
    created () {
        this.options = [
            {
                state: 'all',
                label: this.$t('All verifications'),
            },
            ...Object.values(getStateOptions()),
        ];
    },
};
</script>
